<div class="modal-header">
    <h3 class="modal-title" id="modal-title-id">{{LOCALIZATION.refineBy}} {{facet.displayName}}</h3>
</div>
<div class="modal-body">
    <div class="facet-modal facet-container" style="max-height:600px;overflow-y:auto;overflow-x:hidden">
		<div class="row">  
		    <div class="col-md-6"> 
		        <div>
		            <div class="facetfilter-container">
		                <div class="facetfilter-icon fas fa-search"></div>
		                <input id="facet-filter" name="facet-filter" class="facetfilter-input"
		                       [(ngModel)]="facetfilter"
		                       (focus)="focused = true"
		                       (blur)="focused = false" />
		                <div class="facetfilter-placeholder" 
		                     [class.hidden]="focused === true"
		                     [hidden]="facetfilter.length > 0">
		                    {{ LOCALIZATION.filter }}
		                </div>
		            </div>
		        </div>
		    </div>
		</div>
		<div class="row">  
		    <div class="col-md-12">  
				<div *ngFor="let value of facet.value | facetRefineFilter:facetfilter | facetHideFilter" 
				     class="facet-option">
				  <input type="checkbox" [(ngModel)]="value.checked" (change)="toggleFacet()" />
				  <a (click)="value.checked = true; toggleFacet();" 
				     class="truncate-link pointMe"
				     style="padding-left:4px;" 
				     [title]="value.displayName">
				    {{ value.displayName }}
				  </a>
				  <span class="facet-count" style="vertical-align: top;">{{ value.count }}</span>
				</div>
		    </div>
		</div>		
    </div>
</div>
<div class="modal-footer">
	<button class="btn btn-default" type="button" (click)="close()">{{LOCALIZATION.close}}</button>
    <button class="btn btn-primary" type="button" (click)="search()" [disabled]="values.length == 0">{{LOCALIZATION.search}}</button>
</div>